import {useUserContext} from '@hconnect/login'
import {useUpmPlantContext} from '@hconnect/upm'
import {FeatureFlagConfig, useFeatureFlagsQuery} from '@hproduce/feature-flags'
import {usePermissionsParsedQuery} from '@hproduce/permissions'
import {useMemo} from 'react'

import {getPageAvailability} from '../permissions'

export const usePageAvailability = (plantCode?: string) => {
  const {loggedUser} = useUserContext()
  const {data: permissions} = usePermissionsParsedQuery()
  const {country: countryId, plantId} = useUpmPlantContext()
  const {data: featureFlags} = useFeatureFlagsQuery({
    configurationName: FeatureFlagConfig.Suite,
    params: {plantId: plantCode ?? plantId}
  })

  return useMemo(() => {
    if (!featureFlags || !loggedUser || !plantCode || !permissions) {
      return null
    }
    return getPageAvailability(featureFlags, permissions, countryId, plantCode)
  }, [loggedUser, featureFlags, permissions, countryId, plantCode])
}
